var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

export default isBrowser;
//# sourceMappingURL=isBrowser.js.map